import { render, staticRenderFns } from "./IndicatorButton.vue?vue&type=template&id=f74857be&scoped=true&lang=pug&"
import script from "./IndicatorButton.vue?vue&type=script&lang=js&"
export * from "./IndicatorButton.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorButton.vue?vue&type=style&index=0&id=f74857be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74857be",
  null
  
)

export default component.exports